import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { useTimeZoneService } from "./timeZoneService";
/** RFC 3339 needs an offset (`Z` or `±HH:MM`); a date without one never runs. */
export var hasOffset = function (date) {
    return !!date && /(?:[zZ]|[+-]\d{2}:?\d{2})$/.test(date.trim());
};
var parse = function (instant) {
    if (!instant)
        return null;
    var date = instant instanceof Date ? instant : new Date(instant);
    return Number.isNaN(date.getTime()) ? null : date;
};
/** The two lines of an instant: in the row's zone, then in the viewer's ("my time"). */
export var zonedLines = function (instant, zone, service) {
    var inZone = service.formatDateTimeZone(instant, zone, service.text);
    var inMine = service.formatDateTimeZone(instant, service.myTimeZone, service.text);
    // Both read the same: one line, marked as my time.
    return inZone === inMine
        ? { primary: service.formatMyTime(instant), mine: null }
        : { primary: inZone, mine: service.formatMyTime(instant) };
};
/**
 * An instant in the row's zone and in my time: "09 Apr 2028, 00:00 GMT+4"
 * over "08 Apr 2028, 16:00 EDT · my time", or one line when both are the same.
 */
export var ZonedDateTime = function (_a) {
    var instant = _a.instant, zone = _a.zone, _b = _a.empty, empty = _b === void 0 ? "-" : _b;
    var service = useTimeZoneService();
    var date = parse(instant);
    if (!date)
        return _jsx(_Fragment, { children: empty });
    var _c = zonedLines(date, zone, service), primary = _c.primary, mine = _c.mine;
    return (_jsxs(Box, { component: "span", sx: { display: "inline-flex", flexDirection: "column" }, children: [_jsx(Typography, { component: "span", variant: "body2", children: primary }), mine ? (_jsx(Typography, { component: "span", variant: "body2", color: "text.secondary", children: mine })) : null] }));
};
